const Info = () => {
  return <div>Info. Version 22.10.22-13.00</div>;
};

export default Info;
